// src/services/apiConfig.ts
import axios from 'axios';
import { KeycloakInstance } from 'keycloak-js';

// const BASE_URL = '/'; // 'https://us-east1-ft-knox-413017.cloudfunctions.net/'
const BASE_URL = 'https://us-east1-kutir-corporation.cloudfunctions.net/'; // ''
let keycloakInstance: KeycloakInstance | null = null;

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const initializeApiClient = (keycloak: KeycloakInstance) => {
  keycloakInstance = keycloak;
};

apiClient.interceptors.request.use(
  async (config) => {
    // console.log('Interceptor called');

    if (keycloakInstance) {
      // console.log('keycloak authenticated:', keycloakInstance.authenticated);

      if (keycloakInstance.authenticated) {
        // console.log("Keycloak is authenticated");
        try {
          // Optionally refresh the token
          await keycloakInstance.updateToken(30);

          const token = keycloakInstance.token;
          // console.log("Token:", token);
          
          if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            config.params = {
              ...config.params,
              keycloak_token: token
            };
          } else {
            console.log("Token is null or undefined");
          }
        } catch (error) {
          console.error('Failed to get or refresh token', error);
        }
      } else {
        console.log("Keycloak is not authenticated");
      }
    } else {
      console.log("Keycloak instance not initialized");
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);